/* eslint-disable jsx-a11y/anchor-is-valid */
import useFetch from 'use-http';
import React, { useEffect, useState } from 'react';
import Page from '../../../../../shared/Page';
import Styled from '../../UserAccountPage.styles';
import Loader from '../../../../../shared/Loader';
import Button from '../../../../../shared/Button/Button';
import { AiOutlineEdit } from 'react-icons/ai';
import Modal from '../../../../../shared/Modal/Modal';

const DepartmentEmails = () => {
  const [loading, setLoading] = useState(true);
  const [allDepartments, setAllDepartments] = useState([]);
  const [visibleCount, setVisibleCount] = useState(50);
  const [reload, setReload] = useState(false);

  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState('');
  const [departmentTitle, setDepartmentTitle] = useState('');

  const { get: getDepartments } = useFetch('/UserAccount/Departments');

  const changeReload = () => {
    setLoading(true);
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const fetchDepartments = async () => {
      const res = await getDepartments();

      setAllDepartments(res ?? []);
      setLoading(false);
    };

    fetchDepartments();
  }, [reload, getDepartments]);

  const departments = allDepartments.slice(0, visibleCount);

  return (
    <Page>
      <Styled.DataContainer>
        <Styled.TabTitleWrapper>
          <Styled.TabTitle>Padalinių informacija</Styled.TabTitle>
        </Styled.TabTitleWrapper>

        {loading && (
          <Page>
            <Loader />
          </Page>
        )}

        {!loading &&
          departments.map((department) => (
            <Styled.Visit key={department.departmentId}>
              <Styled.DoctorInfoListRecord>
                <div>
                  <AiOutlineEdit
                    onClick={() => {
                      setEditModalVisible(true);
                      setSelectedDepartmentId(department.departmentId);
                      setSelectedEmail(department.email ?? '');
                      setDepartmentTitle(department.title);
                    }}
                  />
                  <Styled.DoctorName>{department.title}</Styled.DoctorName>
                </div>
                <Styled.DescriptionUrl>
                  {department.email}
                </Styled.DescriptionUrl>
              </Styled.DoctorInfoListRecord>
            </Styled.Visit>
          ))}

        {!loading && visibleCount < allDepartments.length && (
          <Styled.LoadMoreBtn>
            <Button onClick={() => setVisibleCount((prev) => prev + 10)}>
              Rodyti daugiau
            </Button>
          </Styled.LoadMoreBtn>
        )}
      </Styled.DataContainer>

      <Modal
        visible={editModalVisible}
        onClose={() => setEditModalVisible(false)}
        isGrey
        wide
      >
        <Modal.EditDepartmentEmail
          email={selectedEmail}
          changeReload={changeReload}
          selectedDepartmentId={selectedDepartmentId}
          setEditModalVisible={setEditModalVisible}
          departmentTitle={departmentTitle}
        />
      </Modal>
    </Page>
  );
};

export default DepartmentEmails;
